import React, { useRef, useState } from "react";
import { Button, Input, Checkbox } from "@public/ui-toolkit";
import { useFormik } from "formik";
import * as Yup from "yup";
import AuthLayout from "../AuthLayout";

const ForgetPasswordForm = ({ onSubmit, loading }) => {
  const emailEl = useRef(null);
  const formik = useFormik({
    initialValues: {
      emailAddress: "",
    },
    validationSchema: Yup.object({
      emailAddress: Yup.string()
      .email("Invalid email address.")
      .required("Please enter your email address."),

    }),
    onSubmit: (values) => {
      JSON.stringify(values, null, 2);
      onSubmit(values);
    },
  });

  return (
    <div className="initial-screen-content" style={{ minWidth: "520px" }}>
      <h1 className="content-title">Forget Password</h1>
      <form onSubmit={formik.handleSubmit}>
        <div className="row gy-md-4 gy-3">
          <div className="col-12">
            <div className="form-floating">
              <Input
                id="emailAddress"
                placeholder="Email"
                label="Email"
                forr="emailAddress"
                inputRef={emailEl}
                {...formik.getFieldProps("emailAddress")}
              />
              {formik.touched.emailAddress && formik.errors.emailAddress ? (
                <div className="form-error-message">{formik.errors.emailAddress}</div>
              ) : null}
            </div>
          </div>
        </div>
        <Button
          btnName="Continue"
          btnType="primary"
          type="submit"
          loading={loading}
        />
      </form>
    </div>
  );
};

ForgetPasswordForm.propTypes = {};

export default AuthLayout()(ForgetPasswordForm);
